__turbopack_context__.v({
  "className": "red_hat_text_536f4d7d-module__aPm5NG__className",
});
